import Html5 from "../../assets/logos/Html5.png"
import Css3 from "../../assets/logos/Css3.png"
import Javascript from "../../assets/logos/Javascript.png"
import Reactjs from "../../assets/logos/Reactjs.png"
import Nodejs from "../../assets/logos/Nodejs.png"
import Mongodb from "../../assets/logos/Mongodb.png"
import ReactNative from "../../assets/logos/React-native.png"
import Flutter from "../../assets/logos/Flutter.png"
import Kotlin from "../../assets/logos/Kotlin.png"
import Java from "../../assets/logos/Java.png"
import Clang from "../../assets/logos/Clang.png"
import CPPlang from "../../assets/logos/CPPlang.png"
import Python from "../../assets/logos/Python.png"
import ML from "../../assets/logos/Machine-Learning.png"
import PHP from "../../assets/logos/PHP.png"
import MySQL from "../../assets/logos/MySQL.png"
import PostgreSQL from "../../assets/logos/PostgreSQL.png"

const Icon = [
    {
        lang: "HTML/HTML5",
        icon: Html5
    },
    {
        lang: "CSS/CSS3",
        icon: Css3
    },
    {
        lang: "JavaScript",
        icon: Javascript
    },
    {
        lang: "ReactJs",
        icon: Reactjs
    },
    {
        lang: "NodeJs",
        icon: Nodejs
    },
    {
        lang: "MongoDB",
        icon: Mongodb
    },
    {
        lang: "React-Native",
        icon: ReactNative
    },
    {
        lang: "Flutter",
        icon: Flutter
    },
    {
        lang: "Kotlin",
        icon: Kotlin
    },
    {
        lang: "Java",
        icon: Java
    },
    {
        lang: "C",
        icon: Clang
    },
    {
        lang: "C++",
        icon: CPPlang
    },
    {
        lang: "Python",
        icon: Python
    },
    {
        lang: "Machine Learning",
        icon: ML
    },
    {
        lang: "PHP",
        icon: PHP
    },
    {
        lang: "MySQL",
        icon: MySQL
    },
    {
        lang: "PostgreSQL",
        icon: PostgreSQL
    },
    {
        lang: "None"
    }
]

export default Icon